import { render, staticRenderFns } from "./aside-tasks-svg.vue?vue&type=template&id=61505081&scoped=true"
import script from "./aside-tasks-svg.vue?vue&type=script&lang=js"
export * from "./aside-tasks-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61505081",
  null
  
)

export default component.exports